import type { JSX } from 'react'
import type { CardAnimations } from 'blocks/Cards/Card.h'
import type { Animations } from './AnimatedWrapper.h'

import { cloneElement, useRef } from 'react'
import { Transition } from 'react-transition-group'

export interface IAnimatedWrapperProps {
  children: JSX.Element
  transitionName: Animations | CardAnimations | CardAnimations[]
  duration?: number
  transitionEnterTimeout?: number
  transitionLeaveTimeout?: number
  transitionTrigger: boolean
}

export const AnimatedWrapper = ({
  transitionName,
  transitionTrigger,
  duration,
  children,
}: IAnimatedWrapperProps): JSX.Element => {
  const nodeRef = useRef(null)
  return (
    <Transition
      nodeRef={nodeRef}
      in={transitionTrigger}
      timeout={duration || 0}
      exit={false}
    >
      {(state) =>
        cloneElement(children, {
          ref: nodeRef,
          className: `${
            typeof transitionName === 'string'
              ? `${transitionName} ${transitionName}-${state}`
              : transitionName
                  .map((transition) => `${transition} ${transition}-${state}`)
                  .join(' ')
          }`,
        })
      }
    </Transition>
  )
}
